module.exports = __webpack_public_path__ + "plus/img/242f0b8e652d1a94e2a9d81fa2f7d4b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/deps/public/logo.png
// module id = f4mu
// module chunks = 12